// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function ticketCaseComment_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var body = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "body"), null));
  if (body.TAG === /* Ok */0) {
    var author = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "author"), null));
    if (author.TAG === /* Ok */0) {
      var created_at = Timestamp$Catalyst.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
      if (created_at.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  body: body._0,
                  author: author._0,
                  created_at: created_at._0
                }
              };
      }
      var e = created_at._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".created_at" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = author._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".author" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = body._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".body" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function ticket_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var crn = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "crn"), null));
  if (crn.TAG === /* Ok */0) {
    var msisdn = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "msisdn"), null));
    if (msisdn.TAG === /* Ok */0) {
      var caller_number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "caller_number"), null));
      if (caller_number.TAG === /* Ok */0) {
        var case_number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "case_number"), null));
        if (case_number.TAG === /* Ok */0) {
          var city = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "city"), null));
          if (city.TAG === /* Ok */0) {
            var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
            if (status.TAG === /* Ok */0) {
              var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type"), null));
              if (type_.TAG === /* Ok */0) {
                var created_date = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_date"), null));
                if (created_date.TAG === /* Ok */0) {
                  var raised_by = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "raised_by"), null));
                  if (raised_by.TAG === /* Ok */0) {
                    var author = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "author"), null));
                    if (author.TAG === /* Ok */0) {
                      var escalate_to = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "escalate_to"), null));
                      if (escalate_to.TAG === /* Ok */0) {
                        var order_stage = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_stage"), null));
                        if (order_stage.TAG === /* Ok */0) {
                          var issues = Decco.listFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "issues"), null));
                          if (issues.TAG === /* Ok */0) {
                            var actions_taken = Decco.listFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions_taken"), null));
                            if (actions_taken.TAG === /* Ok */0) {
                              var issue_comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "issue_comment"), null));
                              if (issue_comment.TAG === /* Ok */0) {
                                var action_comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "action_comment"), null));
                                if (action_comment.TAG === /* Ok */0) {
                                  var case_comments = Decco.listFromJson(ticketCaseComment_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "case_comments"), null));
                                  if (case_comments.TAG === /* Ok */0) {
                                    return {
                                            TAG: /* Ok */0,
                                            _0: {
                                              crn: crn._0,
                                              msisdn: msisdn._0,
                                              caller_number: caller_number._0,
                                              case_number: case_number._0,
                                              city: city._0,
                                              status: status._0,
                                              type_: type_._0,
                                              created_date: created_date._0,
                                              raised_by: raised_by._0,
                                              author: author._0,
                                              escalate_to: escalate_to._0,
                                              order_stage: order_stage._0,
                                              issues: issues._0,
                                              actions_taken: actions_taken._0,
                                              issue_comment: issue_comment._0,
                                              action_comment: action_comment._0,
                                              case_comments: case_comments._0
                                            }
                                          };
                                  }
                                  var e = case_comments._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".case_comments" + e.path,
                                            message: e.message,
                                            value: e.value
                                          }
                                        };
                                }
                                var e$1 = action_comment._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".action_comment" + e$1.path,
                                          message: e$1.message,
                                          value: e$1.value
                                        }
                                      };
                              }
                              var e$2 = issue_comment._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".issue_comment" + e$2.path,
                                        message: e$2.message,
                                        value: e$2.value
                                      }
                                    };
                            }
                            var e$3 = actions_taken._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".actions_taken" + e$3.path,
                                      message: e$3.message,
                                      value: e$3.value
                                    }
                                  };
                          }
                          var e$4 = issues._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".issues" + e$4.path,
                                    message: e$4.message,
                                    value: e$4.value
                                  }
                                };
                        }
                        var e$5 = order_stage._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".order_stage" + e$5.path,
                                  message: e$5.message,
                                  value: e$5.value
                                }
                              };
                      }
                      var e$6 = escalate_to._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".escalate_to" + e$6.path,
                                message: e$6.message,
                                value: e$6.value
                              }
                            };
                    }
                    var e$7 = author._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".author" + e$7.path,
                              message: e$7.message,
                              value: e$7.value
                            }
                          };
                  }
                  var e$8 = raised_by._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".raised_by" + e$8.path,
                            message: e$8.message,
                            value: e$8.value
                          }
                        };
                }
                var e$9 = created_date._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".created_date" + e$9.path,
                          message: e$9.message,
                          value: e$9.value
                        }
                      };
              }
              var e$10 = type_._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".type" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                      }
                    };
            }
            var e$11 = status._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".status" + e$11.path,
                      message: e$11.message,
                      value: e$11.value
                    }
                  };
          }
          var e$12 = city._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".city" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
        }
        var e$13 = case_number._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".case_number" + e$13.path,
                  message: e$13.message,
                  value: e$13.value
                }
              };
      }
      var e$14 = caller_number._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".caller_number" + e$14.path,
                message: e$14.message,
                value: e$14.value
              }
            };
    }
    var e$15 = msisdn._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".msisdn" + e$15.path,
              message: e$15.message,
              value: e$15.value
            }
          };
  }
  var e$16 = crn._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".crn" + e$16.path,
            message: e$16.message,
            value: e$16.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = ticket_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  ticketCaseComment_decode ,
  ticket_decode ,
  t_decode ,
  
}
/* Timestamp-Catalyst Not a pure module */
